module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBdItalic.woff2?v=3c2a14ee297fed93889b12bc58067d6d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBdItalic.woff2
// module id = 688
// module chunks = 0